module.exports = __webpack_public_path__ + "static/media/logout.c287d9f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logout.svg
// module id = 1058
// module chunks = 0